import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#process", label: "Process" },
  { href: "#about", label: "About" },
  { href: "#careers", label: "Careers" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all ${
        scrolled
          ? "backdrop-blur-xl bg-white/70 border-b fis-hairline"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-3"
        >
          <img
            src="/brand/fis-logo.png"
            alt="FIS logo"
            className="w-10 h-10 object-contain"
          />
          <div className="leading-none">
            <div className="font-display text-base tracking-tight">
              Frontline
            </div>
            <div className="font-mono-label text-[0.6rem] mt-0.5">
              Intelligence System
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm fis-link-underline"
            >
              {l.label}
            </a>
          ))}
          <button
            type="button"
            onClick={() => window.dispatchEvent(new Event("fis:open-quote"))}
            data-testid="nav-link-quote"
            className="text-sm fis-link-underline text-[color:var(--fis-accent)] font-medium"
          >
            Get a Quote
          </button>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/admin"
            data-testid="navbar-admin-link"
            className="font-mono-label text-[0.65rem] hover:text-[color:var(--fis-accent)]"
          >
            Admin
          </Link>
          <a
            href="#contact"
            data-testid="navbar-cta"
            className="fis-btn fis-btn-primary"
          >
            Book a call <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t fis-hairline bg-white">
          <div className="flex flex-col px-6 py-4 gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base"
              >
                {l.label}
              </a>
            ))}
            <Link to="/admin" className="text-base">
              Admin
            </Link>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="fis-btn fis-btn-primary w-fit"
            >
              Book a call
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
